import { RMMClient } from '@nile/graphql';
import { ALL_ASSET_TYPES } from '@nile/rmm/src/constants';
import { GET_ASSETS_FILTER } from '@nile/rmm/src/modules/asset-management/Graphql/asset';
import { COMMON_CONSTANTS } from '@nile/components';
import { isEmpty } from 'lodash';

export const fetchAssetList = (assetIds) => {
  return RMMClient.query({
    query: GET_ASSETS_FILTER,
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
    variables: {
      viewType: ALL_ASSET_TYPES.ALL_MONITORED_ASSET,
      listInfo: {
        condition: {
          joinOperator: 'AND',
          operands: [
            {
              attribute: 'assetId',
              operator: 'includes',
              value: assetIds || []
            }
          ]
        }
      }
    }
  });
};

export const getPurifiedJSON = (json) => {
  const parts = json.split('||');
  let jsonObjects = parts
    .map((part) => {
      try {
        return JSON.parse(part);
      } catch (e) {
        console.error('Error parsing JSON part:', e);
        return null;
      }
    })
    .filter((obj) => obj !== null);
  jsonObjects = { data: jsonObjects?.map((el) => el?.data)?.flat() };
  return jsonObjects || [];
};
export const getScreenshotAttachmentResp = ({
  data: data,
  validFormat = false
}) => {
  let attachment = [];
  let error = null;
  if (validFormat) {
    //For new json format
    const parsedContent = JSON.parse(data?.screenshotResponse || null);
    const hasError =
      parsedContent?.errors || parsedContent?.uploadFileError?.error || null;

    if (!isEmpty(hasError)) {
      if (parsedContent?.errors) {
        error = parsedContent?.errors?.[0]?.errors;
      } else if (parsedContent?.uploadFileError?.error) {
        error = parsedContent?.uploadFileError?.error;
      } else {
        error = parsedContent?.errors;
      }
    } else {
      attachment = parsedContent?.uploadFileResp || [];
    }
  } else {
    //To support older agent version
    const errorObj = data?.screenshotResponse?.UploadFileError;
    const hasError = errorObj?.split('||')?.filter((el) => el?.trim());
    const noError = isEmpty(errorObj) || isEmpty(hasError);
    if (noError) {
      attachment = getPurifiedJSON(data?.screenshotResponse?.UploadFileResp);
    } else {
      error = JSON.stringify(data?.screenshotResponse?.UploadFileError);
    }
  }
  return { attachment, error };
};
